import TryoutSerial from "@/modules/serial/components/Serial";
import TryoutSerialForm from "@/modules/serial/components/Form";

export default [
    {
        path: "/serial",
        name: "TryoutSerial",
        component: TryoutSerial,
    },
    {
        path: "/serial/form",
        name: "TryoutSerialForm",
        component: TryoutSerialForm,
    },
];



// WEBPACK FOOTER //
// ./src/modules/serial/router/serial.js